import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import alertify from "alertifyjs";

const validationSchema = Yup.object().shape({
  emp_code: Yup.string().required("Employee ID is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  message: Yup.string()
    .min(10, "Message must be at least 10 characters")
    .required("Message is required"),
});

const ContactAdmin = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      // For now, just simulate a submission
      // You can replace this with an actual API call
      console.log("Contact form submitted:", data);

      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSubmitted(true);
      alertify.success("Your message has been sent to the administrator.");
      reset();
    } catch (error) {
      alertify.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/">
                  <img src={Applogo} alt="Company Logo" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Contact Admin</h3>
                  <p className="account-subtitle">
                    Having trouble accessing your account? Send a message to the administrator.
                  </p>

                  {submitted ? (
                    <div className="text-center py-4">
                      <div className="mb-4">
                        <i className="fa fa-check-circle text-success" style={{ fontSize: "64px" }}></i>
                      </div>
                      <h4 className="text-success mb-3">Message Sent!</h4>
                      <p className="text-muted mb-4">
                        Your message has been sent to the administrator.
                        They will contact you at the email address provided.
                      </p>
                      <Link to="/" className="btn btn-primary">
                        Back to Login
                      </Link>
                    </div>
                  ) : (
                    <div>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="input-block mb-4">
                          <label className="col-form-label">
                            Employee ID <span className="text-danger">*</span>
                          </label>
                          <Controller
                            name="emp_code"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.emp_code ? "error-input" : ""
                                }`}
                                type="text"
                                placeholder="Enter your Employee ID"
                                onChange={field.onChange}
                                value={field.value || ""}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.emp_code?.message}
                          </span>
                        </div>

                        <div className="input-block mb-4">
                          <label className="col-form-label">
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <Controller
                            name="email"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.email ? "error-input" : ""
                                }`}
                                type="email"
                                placeholder="Enter your email address"
                                onChange={field.onChange}
                                value={field.value || ""}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.email?.message}
                          </span>
                        </div>

                        <div className="input-block mb-4">
                          <label className="col-form-label">
                            Message <span className="text-danger">*</span>
                          </label>
                          <Controller
                            name="message"
                            control={control}
                            render={({ field }) => (
                              <textarea
                                className={`form-control ${
                                  errors?.message ? "error-input" : ""
                                }`}
                                rows={4}
                                placeholder="Describe your issue or inquiry..."
                                onChange={field.onChange}
                                value={field.value || ""}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.message?.message}
                          </span>
                        </div>

                        <div className="input-block text-center">
                          <button
                            className="btn btn-primary account-btn"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Sending...
                              </>
                            ) : (
                              "Send Message"
                            )}
                          </button>
                        </div>
                      </form>

                      <div className="account-footer">
                        <p>
                          Remember your password?{" "}
                          <Link to="/">Back to Login</Link>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAdmin;
